import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

export interface RemoveFromCartDialogData {
  nomeProdotto: string;
  nomeImballo?: string;
  unitaFatturabile?: number;
  unitaMisura?: string;
}

@Component({
  providers: [provideTranslocoScope('products')],
  selector: 'prd-remove-from-cart-dialog',
  imports: [TranslocoPipe,
    MatDialogModule,
    MatButtonModule,
  ],
  templateUrl: './remove-from-cart-dialog.html',
  styleUrl: './remove-from-cart-dialog.scss',
})
export class RemoveFromCartDialog {
  constructor(
    private dialogRef: MatDialogRef<RemoveFromCartDialog, boolean>,
    @Inject(MAT_DIALOG_DATA) readonly data: RemoveFromCartDialogData,
  ) {}

  onCancel() {
    this.dialogRef.close(false);
  }

  onConfirm() {
    this.dialogRef.close(true);
  }
}
